export default "__VITE_ASSET__DfwPPz5p__"